// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oxR6","toggleWrap":"styles_toggleWrap__2StE9","content":"styles_content__3eHR0","selectAreaCode":"styles_selectAreaCode__2-fjo"};